(function () {
    'use strict';

    angular.module("imApp").factory("prodSizeEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 416,
                    parameters: parms || {}
                });
            },
            listCollis: function (parms) {
                return $ihttp.post({
                    method: 913,
                    parameters: parms || {}
                });
            },
            listNobbs: function (parms) {
                return $ihttp.post({
                    method: 1576,
                    parameters: parms || {}
                });
            },
            listColliExamples: function (parms) {
                return $ihttp.post({
                    method: 914,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 417,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
